// eslint-disable-next-line
/* eslint-disable */
import {
    Endpoint
} from "../config";
export default {
    async getMissings(pageNumber = 1, cityId = 0, categoryId = 0) {
        var url = `${Endpoint}/api/missing?pageNumber=${pageNumber}`;

        if (cityId > 0) {
            url = url.concat(`&cityId=${cityId}`);
        }
        if (categoryId > 0) {
            url = url.concat(`&categoryId=${categoryId}`);
        }
        let location = JSON.parse(localStorage.getItem("location"));
        if (location) {
            url = url.concat(`&longitude=${location.longitude}&latitude=${location.latitude}`);
        }
        return await axios.get(url)


    },

    async getUserMissings(pageNumber = 1) {
        var url = `${Endpoint}/api/missing/UserMissings?pageNumber=${pageNumber}`;

        return await axios.get(url)


    },

    async getMissing(id) {
        var url = `${Endpoint}/api/missing/${id}`;

        return await axios.get(url);
    },

    async deleteMissing(id) {
        var url = `${Endpoint}/api/missing/delete/${id}`;

        return await axios.post(url);
    }
}